'use strict';

/**
 *
 * @name: ActionFollowUnfollow
 *
 */

function ActionFollowUnfollow(
  apiUserService,
  $rootScope,
  $stateParams,
  memberAnalytics,
  nnModalsService
  ) {

  'ngInject';

  return {
    restrict: 'C',
    replace: 'false',
    scope: {
      user: '=',
      analyticsLabel: '@'
    },
    compile: function compile(element) {

      $(element).addClass('no-transition');

      return function link(scope, element) {

        var rootWatchers = {};

        $(element).on('click', function(e) {

          e.preventDefault();

          if ($rootScope.profile && $(element).hasClass('action-unfollow')) {

            _unfollow();
          } else if ($rootScope.profile) {

            _follow();
          } else {

            rootWatchers.profile = $rootScope.$watch(function() {

              return $rootScope.profile;
            }, function(newVal) {

              if (newVal) {

                apiUserService
                  .getAnotherUser($stateParams.UserId)
                  .then(function(res) {

                    if (res.data.isFollowed) {
                      scope.user.isFollowed = true;
                    } else {
                      scope.user.isFollowed = false;
                    }

                    rootWatchers.profile();
                  });
              }
            });

            scope.$apply(function() {

              nnModalsService.showModal('login')
            });
          }

        });

        scope.$on('$destroy', function() {

          Object.keys(rootWatchers)
            .forEach(function(killWatcherKey) {

              rootWatchers[killWatcherKey]();
            });
        });

        /* private */

        function _follow() {

          apiUserService
            .follow(scope.user.id)
            .then(function() {

              $rootScope.$broadcast('ucp-reload-followers-counter');
              memberAnalytics.follow(scope.user, scope.analyticsLabel);
              scope.user.isFollowed = true;
              scope.user['followersCount_' + $rootScope.lang2]++;
            });
        }

        function _unfollow() {

          apiUserService
            .followDelete(scope.user.id)
            .then(function() {

              $rootScope.$broadcast('ucp-reload-followers-counter');
              memberAnalytics.unfollow(scope.user, scope.analyticsLabel);
              $(element).removeClass('action-unfollow unfollow').addClass('action-follow follow');

              // follow / followback
              scope.user.isFollowed = false;
              scope.user['followersCount_' + $rootScope.lang2]--;
            });
        }
      };
    }
  };
}

export default ActionFollowUnfollow;



// WEBPACK FOOTER //
// ./app/pages/user/DEPRECATED-action-follow.directive.js